// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sec-header {
  font-size: 15px;
  font-weight: 700;
  margin: 5px 0px 20px;
  color: #555B6D;
}

.box-row {
  margin: 0px 0px 25px;
}

.box-row .card {
  border-radius: 0px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.0392156863);
  border: 0px;
}

.box-row .card-header {
  background: #fff;
  border: 0px;
  color: #4D4F5C;
}

.card-header-title {
  font-size: 15px;
  font-weight: bold;
}

.box-row .card-body.gatepass-saveoutput {
  padding-top: 5px;
}

/* // */
/* DASHBOARD start */
.dash-num-card p {
  opacity: 1;
  font-size: 13px;
  color: #495057;
}

.dash-num-card i img {
  margin-bottom: 1.3rem;
}

.number {
  color: #495057;
  font-size: 20px;
  font-weight: 700;
  margin-top: 16px;
}

.number-txt {
  font-size: 11px;
  font-weight: 700;
}

.rate-up {
  color: #3CC480;
}

.rate-up1 {
  color: #00B6BD;
  font-size: 14px;
  font-weight: bold;
}

.rate-down {
  color: #FF4141;
}

.number-txt .fa-arrow-up {
  color: #3CC480;
  font-size: 11px;
  margin-right: 5px;
}

.number-txt .fa-arrow-down {
  color: #FF4141;
  font-size: 11px;
  margin-right: 5px;
}

div#published-table_length,
div#published-table_filter,
div#published-table_info {
  display: none;
}

thead {
  background: #F5F6FA;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: transparent;
}

.table thead th {
  border: 0px;
  /* color:#A3A6B4; */
  font-size: 13px;
  font-weight: 700;
  color: #495057;
}

.table td {
  /* color:#4D4F5C; */
  font-size: 13px;
  font-weight: 400;
  color: #495057;
}

.card-profile {
  /* width: 30%; */
  background-color: rgba(92, 46, 145, 0.2);
  padding: 10px;
  border-radius: 5px;
  padding-bottom: 39px;
  /* position: absolute; */
  /* left: 15px; */
}

.card-profile p {
  margin: 0px;
  font-size: 11px;
  color: #5C2E91;
}

.designation {
  color: #495057;
  font-size: 10px;
}

.custom-card {
  padding: 1rem;
}

/* .dash-num-card .card-body{
	padding:0px !important;
} */
.card1 {
  font-size: 14px;
  padding: 1.25rem;
}

.card1 p {
  font-size: 14px;
}

.card1 div {
  font-size: 13px;
  margin-top: 16px;
}

.active1 {
  color: #00B6BD !important;
  font-size: 14px !important;
}

.search-box input {
  height: 30px;
}

.reports #brands-table_length,
.reports #product-table_length {
  float: left !important;
}

.reports select {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #CED4DA;
  border-radius: 3px;
  opacity: 1;
  margin: 0px 10px;
  font-size: 13px;
}

.reports label,
#product-table_info,
.paginate_button,
.reports input {
  color: #495057;
  font-size: 13px;
}

.reports input {
  border: 1px solid #CED4DA;
}

.current {
  background-color: #5C2E91;
  color: #fff !important;
  padding: 5px 10px;
  border-radius: 15px;
  margin: 0px 10px;
}

/* DASHBOARD end */`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/dashboardData/DashboardData.scss"],"names":[],"mappings":"AAAA;EACC,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;AACD;;AAEA;EACC,oBAAA;AACD;;AAEA;EACC,kBAAA;EACA,mDAAA;EACA,WAAA;AACD;;AAEA;EACC,gBAAA;EACA,WAAA;EACA,cAAA;AACD;;AAEA;EACC,eAAA;EACA,iBAAA;AACD;;AAEA;EACC,gBAAA;AACD;;AAEA,OAAA;AAEA,oBAAA;AACA;EACC,UAAA;EACA,eAAA;EACA,cAAA;AAAD;;AAGA;EACC,qBAAA;AAAD;;AAGA;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAAD;;AAGA;EACC,eAAA;EACA,gBAAA;AAAD;;AAGA;EACC,cAAA;AAAD;;AAGA;EACC,cAAA;EACA,eAAA;EACA,iBAAA;AAAD;;AAGA;EACC,cAAA;AAAD;;AAGA;EACC,cAAA;EACA,eAAA;EACA,iBAAA;AAAD;;AAGA;EACC,cAAA;EACA,eAAA;EACA,iBAAA;AAAD;;AAGA;;;EAGC,aAAA;AAAD;;AAGA;EACC,mBAAA;AAAD;;AAGA;EACC,6BAAA;AAAD;;AAGA;EACC,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAD;;AAGA;EACC,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAD;;AAGA;EACC,gBAAA;EACA,wCAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,wBAAA;EACA,gBAAA;AAAD;;AAGA;EACC,WAAA;EACA,eAAA;EACA,cAAA;AAAD;;AAGA;EACC,cAAA;EACA,eAAA;AAAD;;AAGA;EACC,aAAA;AAAD;;AAGA;;GAAA;AAGA;EACC,eAAA;EACA,gBAAA;AAAD;;AAGA;EACC,eAAA;AAAD;;AAIA;EACC,eAAA;EACA,gBAAA;AADD;;AAIA;EACC,yBAAA;EACA,0BAAA;AADD;;AAIA;EACC,YAAA;AADD;;AAIA;;EAEC,sBAAA;AADD;;AAIA;EACC,+CAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;AADD;;AAIA;;;;EAIC,cAAA;EACA,eAAA;AADD;;AAKA;EACC,yBAAA;AAFD;;AAKA;EACC,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAFD;;AAKA,kBAAA","sourcesContent":[".sec-header {\n\tfont-size: 15px;\n\tfont-weight: 700;\n\tmargin: 5px 0px 20px;\n\tcolor: #555B6D;\n}\n\n.box-row {\n\tmargin: 0px 0px 25px;\n}\n\n.box-row .card {\n\tborder-radius: 0px;\n\tbox-shadow: 0px 2px 6px #0000000A;\n\tborder: 0px;\n}\n\n.box-row .card-header {\n\tbackground: #fff;\n\tborder: 0px;\n\tcolor: #4D4F5C;\n}\n\n.card-header-title {\n\tfont-size: 15px;\n\tfont-weight: bold;\n}\n\n.box-row .card-body.gatepass-saveoutput {\n\tpadding-top: 5px;\n}\n\n/* // */\n\n/* DASHBOARD start */\n.dash-num-card p {\n\topacity: 1;\n\tfont-size: 13px;\n\tcolor: #495057\n}\n\n.dash-num-card i img {\n\tmargin-bottom: 1.3rem;\n}\n\n.number {\n\tcolor: #495057;\n\tfont-size: 20px;\n\tfont-weight: 700;\n\tmargin-top: 16px;\n}\n\n.number-txt {\n\tfont-size: 11px;\n\tfont-weight: 700;\n}\n\n.rate-up {\n\tcolor: #3CC480;\n}\n\n.rate-up1 {\n\tcolor: #00B6BD;\n\tfont-size: 14px;\n\tfont-weight: bold;\n}\n\n.rate-down {\n\tcolor: #FF4141;\n}\n\n.number-txt .fa-arrow-up {\n\tcolor: #3CC480;\n\tfont-size: 11px;\n\tmargin-right: 5px;\n}\n\n.number-txt .fa-arrow-down {\n\tcolor: #FF4141;\n\tfont-size: 11px;\n\tmargin-right: 5px;\n}\n\ndiv#published-table_length,\ndiv#published-table_filter,\ndiv#published-table_info {\n\tdisplay: none;\n}\n\nthead {\n\tbackground: #F5F6FA;\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n\tbackground-color: transparent;\n}\n\n.table thead th {\n\tborder: 0px;\n\t/* color:#A3A6B4; */\n\tfont-size: 13px;\n\tfont-weight: 700;\n\tcolor: #495057;\n}\n\n.table td {\n\t/* color:#4D4F5C; */\n\tfont-size: 13px;\n\tfont-weight: 400;\n\tcolor: #495057;\n}\n\n.card-profile {\n\t/* width: 30%; */\n\tbackground-color: #5C2E9133;\n\tpadding: 10px;\n\tborder-radius: 5px;\n\tpadding-bottom: 39px;\n\t/* position: absolute; */\n\t/* left: 15px; */\n}\n\n.card-profile p {\n\tmargin: 0px;\n\tfont-size: 11px;\n\tcolor: #5C2E91;\n}\n\n.designation {\n\tcolor: #495057;\n\tfont-size: 10px;\n}\n\n.custom-card {\n\tpadding: 1rem;\n}\n\n/* .dash-num-card .card-body{\n\tpadding:0px !important;\n} */\n.card1 {\n\tfont-size: 14px;\n\tpadding: 1.25rem;\n}\n\n.card1 p {\n\tfont-size: 14px;\n}\n\n\n.card1 div {\n\tfont-size: 13px;\n\tmargin-top: 16px;\n}\n\n.active1 {\n\tcolor: #00B6BD !important;\n\tfont-size: 14px !important;\n}\n\n.search-box input {\n\theight: 30px;\n}\n\n.reports #brands-table_length,\n.reports #product-table_length {\n\tfloat: left !important;\n}\n\n.reports select {\n\tbackground: #FFFFFF 0% 0% no-repeat padding-box;\n\tborder: 1px solid #CED4DA;\n\tborder-radius: 3px;\n\topacity: 1;\n\tmargin: 0px 10px;\n\tfont-size: 13px;\n}\n\n.reports label,\n#product-table_info,\n.paginate_button,\n.reports input {\n\tcolor: #495057;\n\tfont-size: 13px;\n}\n\n\n.reports input {\n\tborder: 1px solid #CED4DA;\n}\n\n.current {\n\tbackground-color: #5C2E91;\n\tcolor: #fff !important;\n\tpadding: 5px 10px;\n\tborder-radius: 15px;\n\tmargin: 0px 10px;\n}\n\n/* DASHBOARD end */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
